<template>
  <div id="header">
    <div class="item">
      <img class="logo" src="./../../assets/logoC.png" alt />
    </div>
    <div class="item msgtsxt">
      <span>欢迎登录永恒安®消防演练评测系统，我们竭诚为您提供专业化服务</span>
      <span class="boldtext">
        热线电话：
        <span class="bluetext">4000969899</span>
      </span>
    </div>
    <div class="item exitbtn">
      <a-popconfirm placement="bottomRight" ok-text="Yes" cancel-text="No" @confirm="confirm">
        <template slot="title">
          <p>
            {{massage}}
          </p>
        </template>
        <a-button icon="logout">退出</a-button>
      </a-popconfirm>
    </div>
  </div>
</template>

<script>
import { message } from 'ant-design-vue';
export default {
  name: "Header",
  data() {
    return {
      massage:"确定退出吗！",
    };
  },
  methods: {
    confirm() {
      localStorage.clear()
      message.info('退出成功');
      this.$router.push("/")
    },
  },
};
</script>
<style scoped>
#header {
  /* width: 1918px; */
  width: 99vw;
  height: 10vh;
  background: #ffffff;
  box-shadow: 1px 4px 7px 0px rgba(45, 45, 44, 0.24);
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  padding: 0 5vw;
  /* margin-bottom: 2vh; */
}
.logo {
  height: 5vh;
}
/* .item{
    float: left;
} */
.boldtext {
  font-weight: bold;
  margin-left: 2vw;
}
.bluetext {
  color: blue;
}
.exitbtn {
  cursor: pointer;
}
.exitbtn:hover {
  color: blueviolet;
}
@media screen and (max-width: 768px){
  .msgtsxt {
  display: none;
}
}
</style>


// WEBPACK FOOTER //
// src/components/Header/Header.vue